import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { mockMode, mockUserMode } from '../../../test/mocks/mock.handler';
import { AllMockModes, AllMockUserModes, MockMode, MockUserMode } from '../../../utility/mock-mode';
import { AuthService } from '../authentication/auth.service';

@Component({
  selector: 'app-mock-selector',
  templateUrl: './mock-selector.component.html',
  standalone: false
})
export class MockSelectorComponent {
  @ViewChild('modalMockConfig') modalMockConfig: TemplateRef<any>;

  // Workaround for accessing in html
  MockMode: any = MockMode; // enum type
  mockMode: any = mockMode; // getter/setter function
  AllMockModes: MockMode[] = AllMockModes; // list of available values
  MockUserMode: any = MockUserMode; // enum type
  mockUserMode: any = mockUserMode; // getter/setter function
  AllMockUserModes: MockUserMode[] = AllMockUserModes; // list of available values

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private authService: AuthService,
    private dialog: MatDialog,
  ) { }

  setMockMode(mode: MockMode) {
    mockMode(mode);

    // For unauthorized, reset auth token (clears cache) and set a token so it will be checked
    if (mode === MockMode.Unauthorized401) {
      this.resetUserCache();
    }
  }

  setMockUserMode(mode: MockUserMode) {
    mockUserMode(mode);
    this.resetUserCache();
  }

  resetUserCache() {
    this.authService.setAuthToken(null);
    this.authService.setAuthToken('mock');
    this.authService.getCurrentUser();
  }

  showModalConfig() {
    this.dialog.open(this.modalMockConfig, {
      width: '30vw',
      minWidth: '400px',
      autoFocus: false
    });
  }

}
